import React, { forwardRef, useImperativeHandle  } from 'react';
import {StyleSheet, Text, View, Image, Pressable} from 'react-native';
import Animated, { useSharedValue, withTiming, useAnimatedStyle, interpolate, cancelAnimation, Easing } from 'react-native-reanimated';


const fps = 60;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

const ProgressBar = forwardRef((props, ref) => {
	
	const style = props.style;
	const width = useSharedValue(0);
	if (props.start) {
		width.value = props.start;
	}
	
	const animatedStyles = useAnimatedStyle(() => ({
		width: interpolate(width.value, [0, 1], [0, 100]).toString()+'%',
		}));
	/*
	this.progressAnim = new Animated.Value(0);
	this.progressInterpolate =
    this.progressAnim.interpolate({
      inputRange: [0, 1],
      outputRange: ["0%", "100%"]
    });
	*/
  useImperativeHandle(ref, () => ({
	  start(to, duration) {
		  /*
		  Animated.timing(this.progressAnim, {
		  toValue: to,
		  easing: Easing.linear,
		  duration: duration,
		  useNativeDriver: false,
		}).start();
		  */
		  
		  width.value = withTiming(to, { duration: duration, easing: Easing.linear,});
	  },
	  
	  stop() {
		  //this.progressAnim.stopAnimation();
		  cancelAnimation(width);
	  },
	  
	  set(to) {
		  //this.progressAnim.setValue(to);
		  width.value = to;
	  },
  }))

    return (
	   <Animated.View style={[style,
        animatedStyles
      ]}>
        </Animated.View>
    );
})

export default ProgressBar;